import angular from 'angular';
import autoCompleteComponent from './autocomplete.directive';
import AutoCompleteService from './autocomplete.service';


let autoCompleteModule = angular.module('shared.components.autoComplete',[])
  .service('AutoCompleteService', AutoCompleteService)
  .directive('autoComplete', autoCompleteComponent);
export default autoCompleteModule;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/shared/components/autocomplete/autocomplete.js
 **/